<div mat-dialog-title aria-label="Report Settings" class="d-flex au-row">
  <h2>{{ data.name }}</h2>
  <button class="ms-auto" mat-button (click)="cancel()">
    <mat-icon color="accent" aria-label="Cancel" class="fa" fontIcon="fa-times"></mat-icon>
  </button>
</div>

<div mat-dialog-content class="flex-column col">
  <div class="padding-lg">
    @for (settingId of data.settings.settingIds; track settingId) {
    <div class="setting px-3">
      <div class="row pt-2 setting-title">
        <!-- Adjust the class based on the condition -->
        <div class="col" [class.col-6]="data.settings[settingId].showOnReportOptionAvailable">
          <h3>{{ data.settings[settingId].title }}</h3>
        </div>
        <!-- Render this column only if showOnReportOptionAvailable is true -->
        @if (data.settings[settingId].showOnReportOptionAvailable) {
        <div class="col-6 text-right">
          @if (data.settings[settingId].refresh) {
          <button mat-icon-button color="primary" (click)="callSettingRefresh(settingId)">
            <mat-icon class="fa fa-rotate-right"></mat-icon>
          </button>
          } @if (data.settings[settingId].displayTextFunction) {
          <mat-slide-toggle
            class="setting-desc-visible"
            color="primary"
            labelPosition="before"
            [(ngModel)]="data.settings[settingId].configs.visible"
            (change)="onSettingsChange()"
            >Show on report</mat-slide-toggle
          >
          }
        </div>
        }
      </div>
      <div class="row pb-3">
        <div class="col">
          @switch (data.settings[settingId].type) { @case ('colorSelector') {
          <div>
            <mat-slide-toggle
              class="mb-4"
              tabindex="-1"
              color="primary"
              (change)="setThemeColorsVisibility(data.settings[settingId])"
              [(ngModel)]="data.settings[settingId].value.active"
              aria-label=""
            >
              {{ data.settings[settingId].displayTextFunction ?
              data.settings[settingId].displayTextFunction() || '' : '' }}
            </mat-slide-toggle>
            @if (data.settings[settingId].id === 'themeColors' &&
            data.settings[settingId].value.active) {
            <div
              class="d-flex flex-sm-row justify-content-sm-start flex-column flex-sm-wrap justify-content-start"
            >
              @for (option of data.settings[settingId].value.selectedColors; track option; let i = $index) {
                <div class="mb-2 d-flex pr-4 justify-content-between color-option-container">
                  @if (option.visible === true && option.label) {
                  <mat-label class="pr-1 align-self-center">{{option.label+':'}}</mat-label>
                  } 
                  
                  @if (option.visible === true) {
                  <input
                    #colorOption
                    type="color"
                    [value]="option.color"
                    (change)="data.settings[settingId].value.selectedColors[i].color = colorOption.value"
                  />
                  }
                </div>
                }
              </div>
            }
          </div>
          } @case ('boolean') {
          <div>
            <mat-slide-toggle
              class="mb-4"
              tabindex="-1"
              color="primary"
              [(ngModel)]="data.settings[settingId].value"
              aria-label=""
            >
              {{ data.settings[settingId].displayTextFunction ?
              data.settings[settingId].displayTextFunction() || '' : '' }}
            </mat-slide-toggle>
          </div>
          } @case ('smallText') {
          <div>
            <mat-form-field>
              @if (settingId === SettingIds.interval) {
              <mat-label>Minutes</mat-label>
              }
              <input
                matInput
                [(ngModel)]="data.settings[settingId].value"
                name="smalltext"
                aria-label=""
              />
            </mat-form-field>
          </div>
          } @case ('profileSelect') {
          <div class="smallTextContainer">
            <mat-form-field>
              <input matInput [(ngModel)]="data.settings[settingId].value.name" />
            </mat-form-field>
          </div>
          } @case ('date') {
          <div>
            <mat-form-field>
              <input
                acsDatePickerEvtHandler
                matInput
                [matDatepicker]="picker"
                [(ngModel)]="data.settings[settingId].value"
              />
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker acsDatePickerEvtHandler #picker></mat-datepicker>
            </mat-form-field>
            <mat-slide-toggle
              color="primary"
              tabindex="-1"
              class="ms-2"
              [(ngModel)]="data.settings[settingId].configs.autoResetDaily"
              aria-label="Reset the date every day"
            >
              Reset daily
            </mat-slide-toggle>
          </div>
          } @case (['multiselect', 'truckDemand'].includes(data.settings[settingId].type) ?
          data.settings[settingId].type : '') {
          <div>
            <acs-option-multi-select [setting]="data.settings[settingId]"></acs-option-multi-select>
          </div>
          } @case ('multiCheck') {
          <div class="d-flex justify-content-between">
            <acs-option-multi-select
              class="d-flex flex-column align-items-center w-100 pb-2"
              [singleColumn]="true"
              [setting]="data.settings[settingId]"
            ></acs-option-multi-select>
          </div>
          } @case ('multiCheckSelect') {
          <div class="d-flex justify-content-between">
            <acs-option-multi-select
              class="d-flex flex-column align-items-center w-100 pb-2"
              [singleColumn]="true"
              [setting]="data.settings[settingId]"
            ></acs-option-multi-select>
          </div>
          } @case ('filterSelect') {
          <div class="d-flex justify-content-start py-2">
            <acs-option-filter-select
              [setting]="data.settings[settingId]"
              (visibilityChanged)="changeVisible($event)"
              class="d-flex flex-row align-items-start w-100 py-2"
            ></acs-option-filter-select>
          </div>
          } @case ('autoComplete') {
          <div>
            <acs-auto-complete
              class="mb-3"
              [(setting)]="data.settings[settingId]"
              [required]="data.settings[settingId].required"
              [productTypeId]="6"
            ></acs-auto-complete>
          </div>
          } @case ('singleSelect') {
          <div class="mat-block">
            <mat-form-field style="min-width: 200px">
              <mat-select
                [disableOptionCentering]="true"
                aria-label="select option"
                [(value)]="data.settings[settingId].value"
                name="option"
              >
                @for (item of data.settings[settingId].options; track
                getIdentifierForIterableItem($index, item)) {
                <mat-option [value]="item"> {{ item.name || item }} </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          } @default {
          <div>[REPORT SETTING OF TYPE {{ settingId }} NOT AVAILABLE]</div>
          } }
        </div>
      </div>
    </div>
    }
  </div>
</div>

<div mat-dialog-actions class="justify-content-end align-items-center">
  <button color="primary" mat-raised-button [disabled]="!hasChanges()" (click)="close()">
    Save
  </button>
</div>
